import { Component, OnInit, inject } from '@angular/core';
import { Upload } from '../../../core/models/upload.model';
import { CaptureInvoiceLineItemImportsService } from '../../../core/services/capture-invoice-line-item-imports.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { isEmpty } from 'lodash-es';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';

import { FileUploadComponent } from '../../../shared/components/file-upload/file-upload.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-capture-admin-import-capture-invoice-line-items',
    templateUrl: './capture-admin-import-capture-invoice-line-items.component.html',
    styleUrls: ['./capture-admin-import-capture-invoice-line-items.component.scss'],
    imports: [ImportNavComponent, FileUploadComponent, FaIconComponent]
})
export class CaptureAdminImportCaptureInvoiceLineItemsComponent implements OnInit {
  private captureInvoiceLineItemImportsService = inject(CaptureInvoiceLineItemImportsService);
  private router = inject(Router);

  uploading = false;
  formModel = {};
  errors: string[] = [];

  ngOnInit() {}

  onUploadStart() {
    this.uploading = true;
    this.errors = [];
  }

  onUploadCancel() {
    this.uploading = false;
  }

  onUploadComplete(upload: Upload) {
    this.captureInvoiceLineItemImportsService.create(upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/tools/import-capture-invoice-line-items/history']);
        this.uploading = false;
      },
      (error: HttpErrorResponse) => {
        this.uploading = false;
        this.errors = error.error.errors;
      }
    );
  }

  onUploadError() {
    this.uploading = false;
  }

  onFormEnter($event) {
    $event.preventDefault();
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
